<template>
  <div class="row bg-secondary-13">
    <div class="col-12 mt-3">
      <em class="icon-shadowed fas fa-file-signature text-orange" />
      <span class="color-gray-7 font-16 font-weight-bold ml-2 mb-2">
        Bitácora de Seguimiento en Remedio Provisional
      </span>
    </div>

    <div class="col-4 my-2">
      <validation-observer ref="blogForm">
        <validation-provider v-slot="{ errors }" :rules="'required'">
          <custom-drop-down
            v-model="commentType"
            :custom-error-msg="'El tipo de comentario es requerido.'"
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Tipo de Comentario:"
            :options="commentTypes"
            placeholder="Seleccione"
          />
        </validation-provider>
      </validation-observer>
    </div>

    <div class="col-12 my-2">
      <BitacoraForm
        comment-label="Comentario"
        @cancel="reset"
        @submit="handleSumbitBlog"
        @validate="$refs.blogForm.validate()"
      />
    </div>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { BitacoraForm } from '@quisit/bitacora';
import alert from 'utils/mixins/alert.mixin.js';

export default {
  name: 'AddBlogItem',
  components: {
    CustomDropDown,
    ValidationObserver,
    ValidationProvider,
    BitacoraForm,
  },
  mixins: [alert],
  props: {
    requestId: {
      type: Number,
      default: 0,
    },
    requestNumber: {
      type: String,
      default: '',
    },
    statusName: {
      type: String,
      default: '',
    },
    statusColor: {
      type: String,
      default: '',
    },
    commentTypes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      commentType: null,
    };
  },
  methods: {
    reset() {
      this.commentType = null;
      this.$refs.blogForm.reset();
      this.$emit('on-open-close');
    },
    async handleSumbitBlog(payload) {
      var isValid = await this.$refs.blogForm.validate();
      if (!isValid) return;

      const data = {
        requestServiceId: this.requestId,
        commentTypeId: this.commentType.id,
        ...payload,
      };

      this.$emit('save', data);
      this.reset();
    },
  },
};
</script>

<style scoped lang="scss">
.dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
}

.icon-shadowed {
  padding: 8px;
  border-radius: 50%;
  display: inline-block;
  opacity: 1;
  background: #fff 0 0 no-repeat padding-box;
  box-shadow: 0 3px 6px #00000029;
}
</style>
